import React from 'react';

import logoNotredame from '../../../../../assets/logo2.png';

import * as S from './styles';

function CartaOrientacao({ form, image }) {
    return (
        <>
            <S.ContainerCartaOrientacao>
                <S.Header>
                    <div>
                        <S.LogoGroup>
                            <S.Logo src={logoNotredame} />
                        </S.LogoGroup>
                    </div>
                    <div>
                        <S.TextBoldCapitalize>Carteirinha Digital</S.TextBoldCapitalize>
                    </div>
                </S.Header>

                <S.BodyCartaOrientacao>
                    <S.Wrapper>
                        <S.Image src={image} alt="Descrição da imagem - Tipo de arquivo: JPG" />
                    </S.Wrapper>
                    <S.Wrapper>
                        <S.Card>
                            <S.DivCardTitle>
                                <S.CardTitleTop1>{form?.numeroCartao}</S.CardTitleTop1>
                                <S.CardTitleTop2>{form?.nome}</S.CardTitleTop2>
                            </S.DivCardTitle>

                            <S.CardItens>
                                <div>
                                    <S.CardTitle>{form?.nome}</S.CardTitle>
                                    <S.CardInfo>Nome</S.CardInfo>
                                </div>
                                <div>
                                    <S.CardTitle>{form?.rede}</S.CardTitle>
                                    <S.CardInfo>Rede</S.CardInfo>
                                </div>
                            </S.CardItens>
                            <S.CardItens>
                                <div>
                                    <S.CardTitle>{form?.titular}</S.CardTitle>
                                    <S.CardInfo>Titular</S.CardInfo>
                                </div>
                                <div>
                                    <S.CardTitle>{form?.segmento}</S.CardTitle>
                                </div>
                            </S.CardItens>
                            <S.CardItens>
                                <div>
                                    <S.CardTitle>{form?.empresa}</S.CardTitle>
                                    <S.CardInfo>Contratante</S.CardInfo>
                                </div>
                                <div>
                                    <S.CardTitle>{form?.acomodacao}</S.CardTitle>
                                    <S.CardInfo>Acomodacao</S.CardInfo>
                                </div>
                            </S.CardItens>
                            <S.CardItens>
                                <div>
                                    <S.CardTitle>{form?.inicioPlano}</S.CardTitle>
                                    <S.CardInfo>Inicio do plano</S.CardInfo>
                                </div>
                                <div>
                                    <S.CardTitle>{form?.plano}</S.CardTitle>
                                    <S.CardInfo>Plano Saude</S.CardInfo>
                                </div>
                            </S.CardItens>
                            <S.CardItens>
                                <div>
                                    <S.CardTitle>{form?.cns}</S.CardTitle>
                                    <S.CardInfo>CNS</S.CardInfo>
                                </div>
                            </S.CardItens>
                            <S.DivisorItem />
                            <S.CardItens>
                                <div>
                                    <S.CardTitle>{form?.fone1}</S.CardTitle>
                                    <S.CardInfo>Central de servicos</S.CardInfo>
                                </div>
                                <div>
                                    <S.CardTitle>{form?.fone2}</S.CardTitle>
                                    <S.CardInfo>Demais Localidades</S.CardInfo>
                                </div>
                                <div>
                                    <S.CardTitle>{form?.fone3}</S.CardTitle>
                                    <S.CardInfo>SAC</S.CardInfo>
                                </div>
                            </S.CardItens>
                        </S.Card>
                    </S.Wrapper>
                </S.BodyCartaOrientacao>
            </S.ContainerCartaOrientacao>
        </>
    );
}

export default CartaOrientacao;
